// extracted by mini-css-extract-plugin
export default {"custom":"Custom_custom__WRNth","block":"Custom_block__n3mGu","icon":"Custom_icon__-xWlQ","marquee":"Custom_marquee__UjcsG"};